export default "__VITE_ASSET__96dc074e__"